<template>
    <SideFormSection>
        <template #title>Subscription</template>
        <template #rawContent>
            <Card
                title="Subscription"
                iconName="credit-card"
            >
                <template #content>
                    <div class="space-y-2">
                        <template v-if="plan.type === PlanTypeEnum.Free">
                            <div>
                                <div class="text-sm">Current plan</div>
                                <div class="font-bold text-xl">Free</div>
                            </div>
                        </template>
                        <template v-else>
                            <div>
                                <span
                                    v-if="
                                        subscription.status ===
                                        SubscriptionStatusEnum.Active
                                    "
                                    class="rounded-full px-2 py-1 bg-green-600 text-white font-semibold uppercase text-sm"
                                >
                                    Active
                                </span>
                                <span
                                    v-else-if="
                                        subscription.status ==
                                        SubscriptionStatusEnum.GracePeriod
                                    "
                                    class="rounded-full px-2 py-1 bg-yellow-400 text-gray-800 font-semibold uppercase text-sm"
                                >
                                    Grace Period
                                </span>
                                <span
                                    v-else-if="
                                        subscription.status ==
                                        SubscriptionStatusEnum.Canceled
                                    "
                                    class="rounded-full px-2 py-1 bg-red-600 text-white font-semibold uppercase text-sm"
                                >
                                    Canceled
                                </span>
                            </div>
                            <div
                                v-if="
                                    subscription.status ==
                                    SubscriptionStatusEnum.Active
                                "
                                class="space-y-2"
                            >
                                <div>
                                    <div class="text-sm">Current plan</div>
                                    <div class="font-bold text-xl">
                                        {{ plan.name }}
                                    </div>
                                </div>
                                <div>
                                    Start date: {{ subscription.subscribedAt }}
                                </div>
                                <div>
                                    <div class="mb-1">Plan features:</div>
                                    <div
                                        class="text-sm text-gray-800 space-y-1.5"
                                    >
                                        <FeatureList
                                            :features="plan.featuresDisplay"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                v-else-if="
                                    subscription.status ==
                                    SubscriptionStatusEnum.GracePeriod
                                "
                            >
                                Until: {{ subscription.gracePeriodEndsAt }}
                            </div>
                            <div
                                v-else-if="
                                    subscription.status ==
                                    SubscriptionStatusEnum.Canceled
                                "
                            >
                                Canceled at: {{ subscription.canceledAt }}
                            </div>
                        </template>
                    </div>

                    <div class="flex justify-end">
                        <template v-if="plan.type === PlanTypeEnum.Free">
                            <div class="flex gap-2">
                                <Button
                                    as="a"
                                    :href="
                                        urlFactory.makeBillingSubscriptionPlansIndexPageUrl()
                                    "
                                    color="dark"
                                    :iconRight="true"
                                    iconName="arrow-right"
                                >
                                    Available Plans
                                </Button>
                            </div>
                        </template>
                        <template
                            v-else-if="
                                subscription.status ===
                                SubscriptionStatusEnum.GracePeriod
                            "
                        >
                            <div class="flex gap-2">
                                <Button
                                    as="a"
                                    :href="
                                        urlFactory.makeBillingPaddleCustomerPortalRedirectUrl()
                                    "
                                    color="light"
                                    target="blank"
                                >
                                    Manage Subscription
                                </Button>
                            </div>
                        </template>
                        <template
                            v-else-if="
                                subscription.status ===
                                SubscriptionStatusEnum.Active
                            "
                        >
                            <div class="flex gap-2">
                                <Button
                                    as="a"
                                    :href="
                                        urlFactory.makeBillingChangePlanPageUrl()
                                    "
                                    color="light"
                                >
                                    Change Plan
                                </Button>
                                <Button
                                    as="a"
                                    :href="
                                        urlFactory.makeBillingPaddleCustomerPortalRedirectUrl()
                                    "
                                    color="light"
                                    target="blank"
                                >
                                    Manage Subscription
                                </Button>
                            </div>
                        </template>
                    </div>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Subscription from '@/App/Subscription/Entity/Subscription'
    import Plan from '@/App/Plan/Entity/Plan'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Button from '@/Shared/Component/Button.vue'
    import FeatureList from '@/App/Plan/Component/FeatureList.vue'
    import Card from '@/Shared/Component/Card.vue'
    import {
        PlanTypeEnum,
        SubscriptionStatusEnum,
    } from '@/Shared/AutoGenerated/Main'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    const props = defineProps({
        subscription: {
            type: Object as PropType<Subscription>,
            required: true,
        },
        plan: {
            type: Object as PropType<Plan>,
            required: true,
        },
    })

    const urlFactory = new UrlFactory()
</script>
